import React, { lazy, Suspense } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UnauthenticatedTemplate, useMsal, AuthenticatedTemplate } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import PostalAddress from '../components/PostalAddress';
import annonceCouple from '../images/annonce-couple.jpg';
import annonceBaiser from '../images/annonce-baiser.jpg';
import annonceLeslie from '../images/annonce-leslie.jpg';

const SimpleCarousel = lazy(() => import('../components/SimpleCarousel'));

const HomePage = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  // Création de compte : l'action principale, la plupart des invités
  // arrivent sans accès.
  const handleSignUpRedirect = async () => {
    try {
      const res = await fetch("/api/config");
      const config = await res.json();
      await instance.loginRedirect({
        ...loginRequest({ SP_API_ENDPOINT: config.SP_API_ENDPOINT }),
        prompt: 'create',
      });
    } catch (error) {
      console.error("Erreur lors de la création du compte :", error);
    }
  };

  const handleLoginRedirect = async () => {
    try {
      const res = await fetch("/api/config");
      const config = await res.json();
      await instance.loginRedirect(loginRequest({
        SP_API_ENDPOINT: config.SP_API_ENDPOINT
      }));
    } catch (error) {
      console.error("Erreur de connexion :", error);
    }
  };

  return (
    <div>
      <div className="hero home-hero">
        <div className="hero-inner">
          <div className="inner">
            <h1 className="home-hero-title">Leslie &amp; Loïc s'agrandissent</h1>
            <p className="home-hero-date">Bébé arrive le 14 novembre 2026</p>
          </div>
        </div>
      </div>

      <section className="home-section">
        <h2>Un heureux événement se prépare</h2>
        <p className="home-lead">
          Après notre mariage, une nouvelle aventure commence : nous attendons
          notre premier enfant, dont l'arrivée est prévue aux alentours du{' '}
          <strong>14 novembre 2026</strong>.
        </p>
        <p>
          Nous avons préparé une liste de naissance pour celles et ceux qui
          souhaitent nous accompagner dans cette nouvelle étape. Vous pouvez y
          participer librement, même pour une petite part d'un cadeau, et à
          plusieurs sur un même cadeau. Les détails sont dans la{' '}
          <Link to="/faq">foire aux questions</Link>.
        </p>

        {/* La grande photo porte l'annonce, les deux autres la complètent ;
            sous 700px tout repasse sur une seule colonne. */}
        <figure className="home-annonce">
          <div className="home-annonce-grid">
            <img
              className="home-annonce-main"
              src={annonceCouple}
              alt="Leslie et Loïc posant tous les deux dans le jardin, au soleil couchant"
              width="1050"
              height="1400"
              loading="lazy"
              decoding="async"
            />
            <img
              src={annonceBaiser}
              alt="Leslie et Loïc s'embrassant à contre-jour"
              width="1400"
              height="1050"
              loading="lazy"
              decoding="async"
            />
            <img
              src={annonceLeslie}
              alt="Leslie riant, assise parmi les invités"
              width="1400"
              height="1050"
              loading="lazy"
              decoding="async"
            />
          </div>
          <figcaption>Septembre 2026 — et bientôt, nous serons trois.</figcaption>
        </figure>
      </section>

      <UnauthenticatedTemplate>
        <section className="home-section">
          <div className="home-cta">
            <button type="button" className="home-cta-button" onClick={handleSignUpRedirect}>
              Créer mon accès
            </button>
          </div>
          <p className="home-cta-note">
            L'accès est privé : la liste et les photos ne sont visibles que des
            personnes inscrites. La création de compte prend une minute, avec
            votre adresse email et un code reçu par mail.
          </p>
          <button type="button" className="home-cta-secondary" onClick={handleLoginRedirect}>
            J'ai déjà un compte
          </button>
        </section>
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <section className="home-section">
          <div className="home-cta-buttons">
            <button type="button" className="home-cta-button" onClick={() => navigate('/liste-naissance')}>
              Voir la liste de naissance
            </button>
            <button type="button" className="home-cta-button" onClick={() => navigate('/galerie')}>
              Voir les photos du mariage
            </button>
          </div>
          <PostalAddress />
        </section>
      </AuthenticatedTemplate>

      <section className="home-section home-practical">
        <h3>En pratique</h3>
        <ul>
          <li>
            <strong>Participer à un cadeau :</strong> vous choisissez le montant
            que vous souhaitez offrir, il n'est pas nécessaire de financer un
            cadeau en entier. Plusieurs personnes peuvent participer au même cadeau.
          </li>
          <li>
            <strong>Jusqu'à quand :</strong> la liste reste ouverte jusqu'à la
            naissance, mi-novembre 2026.
          </li>
          <li>
            <strong>Envoyer quelque chose par la poste :</strong> c'est possible
            dès maintenant. Notre adresse s'affiche sur cette page une fois que
            vous êtes connecté.
          </li>
          <li>
            <strong>Un souci pour créer votre accès ou pour contribuer :</strong>{' '}
            écrivez-nous directement, on vous répond vite.
          </li>
        </ul>
      </section>

      <Suspense fallback={<div />}>
        <SimpleCarousel />
      </Suspense>
    </div>
  );
};

export default HomePage;
